<template lang="pug">
  .crud
    modal-import(model="products" :title="$t('front.import_modal', {model: $t('strings.products')})")
    modal-products(:form='form', :is-add='isModalAdd')
    modal-product-top-suppliers(:productId='productId')
    modal-attachmentspro(:form='form')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.products') }}:
            span {{ $t('strings.description', {attribute: $t('strings.products')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addProduct") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteProductsConfirm" :disabled="!enabledDelete")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
                    vm-icon(icon="upload-outline")
                    slot &nbsp;{{ $t('strings.import') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="products")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
                div
                  vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px")
                    div(v-for="(item,index) in columns")
                      vm-select-item(:key="item + ',asc'" v-if="item !== '' && item !== 'sku'" :value="item + ',asc'" :text="$t('products.'+ item) + ', asc'")
                      vm-select-item(:key="item + ',desc'" v-if="item !== '' && item !== 'sku'" :value="item + ',desc'" :text="$t('products.'+ item) + ', desc'")
                      vm-select-item(:key="item + ',asc'" v-if="item === 'sku'" value="id,asc" :text="$t('products.sku') + ', asc'")
                      vm-select-item(:key="item + ',desc'" v-if="item === 'sku'" value="id,desc" :text="$t('products.sku') + ', desc'")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('products.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('products.' + column) }}
              vm-th
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  .row(@click="showTopSuppliers(data[indextr])")
                    slot(v-if="column == 'total' || column == 'price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status' && column != 'total' && column != 'price'  && column != 'unit_measurement_id' && column != 'currency_id' && column != 'product_category_id'") {{data[indextr][column] }}
                    slot(v-if="column == 'unit_measurement_id'") {{data[indextr]['unit_measurement']['name']}}
                    slot(v-if="column == 'currency_id'") {{data[indextr]['currency']['name']}}
                    slot(v-if="column == 'product_category_id' && data[indextr][column]") {{data[indextr]['product_category']['name']}}
                    vm-chip(v-if="column == 'status'" :color="colorStatus(data[indextr][column])") {{data[indextr]['status_display']}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="editProduct(data[indextr], tr)")
                        vm-icon(icon="edit-2-outline")
                        slot &nbsp;{{ $t('strings.edit') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="editFiles(data[indextr], tr)")
                        vm-icon(icon="edit-2-outline")
                        slot &nbsp;{{ $t('strings.edit_files') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="download({id: hasTech(data[indextr], indextr)}, indextr)" v-if='hasTech(data[indextr], indextr)')
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('products.tech_sheet') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="download({id: hasSecurity(data[indextr], indextr)}, indextr)" v-if='hasSecurity(data[indextr], indextr)')
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('products.security_sheet') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteProductConfirm(data[indextr])")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalProducts from '@/components/modals/ModalProducts.vue'
import ModalAttachmentspro from '@/components/modals/ModalAttachmentspro.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import ModalProductTopSuppliers from '@/components/modals/ModalProductTopSuppliers.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Products')

export default {
  name: 'Products',
  components: {
    ModalProducts,
    ModalImport,
    ModalProductTopSuppliers,
    ModalAttachmentspro
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    productId: '',
    form: {},
    selected: [],
    enabledDelete: false,
    columns: [
      'sku',
      'name',
      'number_part',
      'price',
      'unit_measurement_id',
      'currency_id',
      'product_category_id'
    ],
    status: [
      // Agregar los estatus si maneja
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        sku: '',
        name: '',
        number_part: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  computed: {
    ...mapGetters([
      'products',
      'productsCatalog',
      'pagination',
      'filterParams'
    ]),
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getProducts(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.currentPage = 1
      this.selected = []
      this.getProducts(this.currentPage)
    },
    selected (selected) {
      this.enabledDelete = selected.length > 0
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    this.currentPage = this.pagination.currentPage
    await this.getProducts(this.currentPage)
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'deleteProduct',
      'deleteProducts',
      'loadProducts',
      'loadCatalog',
      'actionProduct',
      'setModalImportVisible',
      'setModalVisible',
      'setModalTopSuppliersVisible',
      'setModalAttachVisible',
      'printReport',
      'applyFilter',
      'clearFilter',
      'download'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    addProduct () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.form = {}
    },
    editProduct (product, index) {
      this.isModalAdd = false
      this.form = { ...product }
      this.setModalVisible(true)
    },
    editFiles (product, index) {
      this.form = { ...product }
      this.setModalAttachVisible(true)
    },
    async deleteProductConfirm (product) {
      let t = this
      this.auxDeleteProduct = () => {
        t.deleteProduct(product).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', { model: this.$t('strings.product'), attribute: this.$t(product.sku) }),
        accept: this.auxDeleteProduct
      })
    },
    async deleteProductsConfirm () {
      let t = this
      let productsMany = parseDeleteMany(this.selected, 'sku')
      this.auxDeleteProduct = () => {
        t.deleteProducts(productsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', { model: this.$t('strings.product'), attribute: productsMany.values }),
        accept: this.auxDeleteProduct
      })
    },
    async setActionProduct (record, action) {
      record.id && this.actionProduct({ id: record.id, action })
    },
    async getProducts (page) {
      let t = this
      this.loadProducts({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let product = this.products.filter(product => product.id === parseInt(index))[0]
      product && this.editProduct(product, index)
    },
    async getCatalog () {
      Object.keys(this.productsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    handleChange (date) {
      this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    showTopSuppliers (product) {
      this.productId = product.id
      this.setModalTopSuppliersVisible(true)
    },
    hasTech (product, index) {
      var id = product.attachments.find(a => a.pivot.file_type === 'tech_sheet')
      return id ? id.id : ''
    },
    hasSecurity (product, index) {
      var id = product.attachments.find(a => a.pivot.file_type === 'security_sheet')
      return id ? id.id : ''
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
